if (!customElements.get('rta-product-description')) {
  customElements.define(
    'rta-product-description',
    class RtaProductDescription extends HTMLElement {
      connectedCallback() {
        this.content = this.querySelector('[data-rta-product-description-content]');
        this.toggle = this.querySelector('[data-rta-product-description-toggle]');
        this.moreLabel = this.querySelector('[data-rta-product-description-more]');
        this.lessLabel = this.querySelector('[data-rta-product-description-less]');

        if (!this.content || !this.toggle) return;

        this.lines = Number.parseInt(this.dataset.lines || '6', 10);
        this.handleToggle = this.handleToggle.bind(this);
        this.measure = this.measure.bind(this);
        this.toggle.addEventListener('click', this.handleToggle);

        this.resizeObserver = new ResizeObserver(this.measure);
        this.resizeObserver.observe(this.content);
        requestAnimationFrame(this.measure);
      }

      disconnectedCallback() {
        this.toggle?.removeEventListener('click', this.handleToggle);
        this.resizeObserver?.disconnect();
      }

      measure() {
        const lineHeight = Number.parseFloat(getComputedStyle(this.content).lineHeight);
        if (!Number.isFinite(lineHeight) || !Number.isFinite(this.lines)) return;

        const collapsedHeight = lineHeight * this.lines;
        this.style.setProperty('--rta-product-description-collapsed-height', `${collapsedHeight}px`);

        const isOverflowing = this.content.scrollHeight > collapsedHeight + 1;
        this.classList.toggle('is-collapsible', isOverflowing);
        this.toggle.hidden = !isOverflowing;

        if (!isOverflowing) this.setExpanded(false);
      }

      handleToggle() {
        this.setExpanded(!this.classList.contains('is-expanded'));
      }

      setExpanded(expanded) {
        this.classList.toggle('is-expanded', expanded);
        this.toggle.setAttribute('aria-expanded', String(expanded));
        if (this.moreLabel) this.moreLabel.hidden = expanded;
        if (this.lessLabel) this.lessLabel.hidden = !expanded;
      }
    },
  );
}
